import { Field as BaseField } from '../vertical/Field';
import { withCols } from './utils';

/** Renders the layout for a horizontal field with a label. */
export const Field = withCols(BaseField);
